import { getNozzleDirectionOptions, getNozzleTypes } from "@/common/filter"
import { SimiulatorEquipment, SimulatorNozzle } from "@/types/equipment"
import { Divider, Form, Input, InputNumber, Modal, ModalProps, Select, Typography } from "antd"
import { useEffect, useState } from "react"
import { NozzleType } from "@/types/common"
import { useRequest } from "ahooks"
import { addNozzleToEquipment, updateEquipmentNozzle } from "@/services/project/equipment/equipment.service"
import { createRoot } from "react-dom/client"
import { getNozzleShapes } from "@/services/admin/nozzle-shape/NozzleShape.service"

interface AddNozzleProps extends ModalProps {
  projectId?: number
  nozzle?: SimulatorNozzle
  onSuccess?: () => void
  equipment?: SimiulatorEquipment
}

export function AddEditNozzle(props: AddNozzleProps)  {
  const { equipment, onSuccess, onCancel, nozzle } = props
  const [form] = Form.useForm()
  const [type, setType] = useState<NozzleType | undefined>()
  const [shapes, setShapes] = useState<{value: number, label: string}[]>([])

  useEffect(() => {
    getNozzleShapes().then((resShapes) => {
      const shapeOptions = resShapes.map((item) => {
        return {value: item.id, label: item.name}
      })
      setShapes(shapeOptions)
      if (nozzle) {
        setType(nozzle.type)
        form.setFieldsValue({
          name: nozzle.name,
          type: nozzle.type,
          shapeId: nozzle.shape?.id,
          direction: nozzle.direction,
          x: nozzle.customLayout?.x,
          y: nozzle.customLayout?.y
        })
      }
    })
  }, [])


  const { loading, run } = useRequest(
    (values) => {
      if (nozzle) {
        console.log(values)
        return updateEquipmentNozzle(values, {equipmentId: equipment!.id, id: nozzle.id})
      }
      return addNozzleToEquipment(equipment!.id, values)
    },
    {
      manual: true,
      onSuccess: () => {
        handleCancel()
        onSuccess?.()
      },
      onFinally: () => {
        form.resetFields()
      }
    }
  )

  const handleCancel = (e?) => {
    onCancel?.(e)
    form.resetFields()
  }


  return <Modal
    {...props}
    width={600}
    open={true}
    onCancel={handleCancel}
    onOk={() => form.submit()}
  >
    <div>Add Nozzle</div>
    <Form
      form={form}
      onFinish={(values) => {
        values.customLayout = {
          x: values.x,
          y: values.y,
        }
        if (values.shapeId) {
          values.customLayout.angle = 0;
          values.customLayout.width = 20;
          values.customLayout.height = 20;
        }
        run(values)
      }}
      className="mt-4"
    >
      <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter nozzle name' }]}>
        <Input type='text' />
      </Form.Item>

      <Form.Item label='Type' name='type' rules={[{ required: true, message: 'Please selected a nozzle type' }]}>
        <Select options={getNozzleTypes()} onChange={(val) => setType(val)}/>
      </Form.Item>
      <Form.Item label='X' name='x' rules={[{ required: true, message: 'Please enter nozzle X' }]}>
        <InputNumber />
      </Form.Item>
      <Form.Item label='Y' name='y' rules={[{ required: true, message: 'Please enter nozzle Y' }]}>
        <InputNumber />
      </Form.Item>
      
      {[NozzleType.FlowNozzle, NozzleType.EnergyFlowNozzle].includes(type as NozzleType) && <div>
        <Divider />

        <Typography.Title level={5}>Optional by type</Typography.Title>
        {type === NozzleType.FlowNozzle && <Form.Item label='Shape' name='shapeId'>
          <Select options={shapes} disabled={!!nozzle} />
        </Form.Item>}
        <Form.Item label='Direction' name='direction'>
          <Select options={getNozzleDirectionOptions()} />
        </Form.Item>
      </div>}
      
    </Form>
  </Modal>
}

AddEditNozzle.show = (props: AddNozzleProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div);
  root.render(<AddEditNozzle
    {...props}
    onCancel={(e) => {
      props.onCancel?.(e)
      root.unmount()
    }}
  />);
}